import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import ConsultationForm from './components/ConsultationForm';
import ProjectEstimator from './components/ProjectEstimator';
import OfficeLocations from './components/OfficeLocations';
import FAQSection from './components/FAQSection';
import TrustSignals from './components/TrustSignals';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us - Devontis Technologies | Start Your Digital Transformation</title>
        <meta
          name="description"
          content="Get in touch with Devontis Technologies for your SaaS development needs. Schedule a free consultation, get project estimates, and connect with our expert team."
        />
        <meta
          name="keywords"
          content="contact devontis, saas consultation, project estimate, software development inquiry, tech consultation"
        />
        <meta property="og:title" content="Contact Us - Devontis Technologies" />
        <meta
          property="og:description"
          content="Connect with our expert team for your SaaS development project. Free consultation available."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-background pt-16">
        {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Breadcrumbs />
        </div> */}

        <ContactHero />
        <ContactMethods />
        <ConsultationForm />
        <ProjectEstimator />
        <TrustSignals />
        {/* <OfficeLocations /> */}
        <FAQSection />
      </main>

      <Footer />
    </>
  );
};

export default Contact;